import { render, staticRenderFns } from "./NewUserRoleModal.vue?vue&type=template&id=1dfa91fe"
import script from "./NewUserRoleModal.vue?vue&type=script&lang=js"
export * from "./NewUserRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports